import react, { forwardRef } from "react";

export function formatDateToUserTimeZone(dateInput) {
  try {
    const date = new Date(dateInput);

    if (isNaN(date)) throw new Error("Invalid date");

    const options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "Asia/Kolkata",
    };

    // Format using 'en-US' locale for MM/DD/YYYY
    const formatted = new Intl.DateTimeFormat("en-US", options).format(date);

    return formatted.replace(",", ""); // Remove the comma between date and time
  } catch (error) {
    console.error("Invalid date input:", dateInput);
    return "Invalid Date";
  }
}

export const formatDateToUser = (date) => {
  if (!date) return "—";
  const localDate = new Date(date);
  const month = String(localDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(localDate.getDate()).padStart(2, "0");
  const year = localDate.getFullYear();
  return `${month}/${day}/${year}`; // MM/DD/YYYY
};

export const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
  <div
    className="input-group w-100"
    onClick={onClick}
    style={{ cursor: "pointer" }}
  >
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      ref={ref}
      placeholder="MM/DD/YYYY"
      style={{ height: "38px"}}
    />
    <span
      className="input-group-text"
      style={{ height: "38px", display: "flex", alignItems: "center" ,border:"1px solid var(--dark-color)"}}
    >
      <i className="bi bi-calendar" style={{ fontSize: "1rem" }}></i>
    </span>
  </div>
));
